export const createObserverPin = () => {
  const pin = document.createElement("div");
  pin.setAttribute("role", "img");
  pin.setAttribute("aria-label", "Observer location");
  pin.title = "Observer location";
  Object.assign(pin.style, {
    width: "18px",
    height: "18px",
    background: "#3986ef",
    border: "2px solid white",
    borderRadius: "50% 50% 50% 0",
    transform: "rotate(-45deg)",
    pointerEvents: "none",
    boxSizing: "border-box",
  });
  return pin;
};
